import { render } from "./product.vue?vue&type=template&id=609cf428"
import script from "./product.vue?vue&type=script&lang=js"
export * from "./product.vue?vue&type=script&lang=js"

import "./product.vue?vue&type=style&index=0&id=609cf428&lang=css"
script.render = render

export default script